/**
 * Patients Route
 * Patient directory and management page
 * Layout provided by _authenticated parent route
 * Authentication inherited from parent
 */

import { createFileRoute } from '@tanstack/react-router';
import { PatientsPage } from '../../pages/Patients/PatientsPage';

/**
 * Patients Route Component
 * Layout (MainLayout, Sidebar, sessions panel) provided by parent _authenticated route
 */
const PatientsRouteComponent = () => {
  return <PatientsPage />;
};

/**
 * Route Configuration
 * Path: /_authenticated/patients
 * - Authentication inherited from _authenticated parent (no requireAuth needed)
 * - MainLayout structure inherited from _authenticated parent
 */
export const Route = createFileRoute('/_authenticated/patients/')({
  component: PatientsRouteComponent,
});
